import Konva from 'konva';
import Helpers from '../Helpers';
import ConfiguratorData from './ConfiguratorData';

let object = null;

class ConfiguratorPerson {

    constructor(configurator) {

        if(!object) {
            object = this;
        }

        this.helpers = new Helpers(); /*Экземпляр хэлперов*/
        this.configData = new ConfiguratorData();/*Общее хранилище данных*/
        this.configurator = configurator;/*Экземпляр конфигуратора*/

        this.group = new Konva.Group({
            x: 0,
            y: 0,
            width: configurator.containerWidth,
            height: configurator.containerHeight,
            draggable: false
        });

        /*Масштаб картинок*/
        this.scale = 0.3;

        this.position = {
            x: 0,
            y: 0,
        };

        /*Размер картинок*/
        this.imageSize = 1400;

        /*Данные человека*/
        this.imagePath = '/wp-content/canvas/Person/Natali/';
        this.personImage  = {
            front: {
                src: this.imagePath + 'Natali-03-optimized.png',
                shadow: this.imagePath + 'Natali-03-shadow-optimized.png',
                img: null,
                shadowImg: null,
            },
            frontLeft: {
                src: this.imagePath + 'Natali-04-optimized.png',
                shadow: this.imagePath + 'Natali-04-shadow-optimized.png',
                img: null,
                shadowImg: null,
            },
            frontRight: {
                src: this.imagePath + 'Natali-02-optimized.png',
                shadow: this.imagePath + 'Natali-02-shadow-optimized.png',
                img: null,
                shadowImg: null,
            },
            back: {
                src: this.imagePath + 'Natali-01-optimized.png',
                shadow: this.imagePath + 'Natali-01-shadow-optimized.png',
                img: null,
                shadowImg: null,
            },
        };

        this.isDrew = false;

        // listen options
        this.debug = (window.location.hash === '#debug');

        return object;
    }

    // Нарисовать человека
    drawPerson(item) {
        let object = this;

        this.position.x = item.x;
        this.position.y = item.y;
        this.group.x(item.x);
        this.group.y(item.y);

        let x = item.x;
        let y = item.y;

        let img, shadowImg;

        if(item.position === 'front') {
            img = this.personImage['front']['img'];
            shadowImg = this.personImage['front']['shadowImg'];
        }
        else if (item.position === 'frontLeft') {
            img = this.personImage['frontLeft']['img'];
            shadowImg = this.personImage['frontLeft']['shadowImg'];
        }
        else if(item.position === 'frontRight'){
            img = this.personImage['frontRight']['img'];
            shadowImg = this.personImage['frontRight']['shadowImg'];
        }
        else {
            img = this.personImage['back']['img'];
            shadowImg = this.personImage['back']['shadowImg'];
        }

        let image = new Konva.Image({
            x: 0,
            y: 0,
            width: object.imageSize,
            height: object.imageSize,
            listening: object.debug,
            draggable: object.debug,
            image: img,
            scaleX: object.scale,
            scaleY: object.scale,
            name: 'person-image',
        });

        let shadow = new Konva.Image({
            x: 0,
            y: 0,
            listening: false,
            image: shadowImg,
            width: object.imageSize,
            height: object.imageSize,
            scaleX: object.scale,
            scaleY: object.scale,
            name: 'person-shadow',
        });

        object.group.add(shadow);
        object.group.add(image);

        shadow.zIndex(0);

        /*if((item.position === 'back' && !item.isAngle) || item.position === 'frontLeft') {
            image.zIndex(object.group.children.length - image.index);
        }

        if(item.position === 'front' && item.isAngle) {
            image.zIndex(1);
        }*/

        this.isDrew = true;
    }
}

export default ConfiguratorPerson;
